import { render, staticRenderFns } from "./account-query.vue?vue&type=template&id=2d8bbeaf&scoped=true"
import script from "./account-query.vue?vue&type=script&lang=ts"
export * from "./account-query.vue?vue&type=script&lang=ts"
import style0 from "./account-query.vue?vue&type=style&index=0&id=2d8bbeaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8bbeaf",
  null
  
)

export default component.exports